
const features = [
  {
    icon: 'ri-restaurant-line',
    title: 'بوفيه فطور يومي',
    description: 'تشكيلة واسعة ومتجددة من الأطباق الساخنة والباردة والمخبوزات الطازجة يوميًا'
  },
  {
    icon: 'ri-hotel-line',
    title: 'أجواء فندقية راقية',
    description: 'تصميم داخلي عصري وفخم يوفر تجربة طعام مريحة في بيئة فندقية استثنائية'
  },
  {
    icon: 'ri-cake-3-line',
    title: 'تنوع في المخبوزات',
    description: 'مخبوزات طازجة محضرة يوميًا من الكرواسون والمعجنات إلى الخبز التقليدي'
  },
  {
    icon: 'ri-user-star-line',
    title: 'طاقم خدمة محترف',
    description: 'فريق عمل مدرب على أعلى معايير الضيافة الفندقية لضمان راحتكم التامة'
  }
];

export default function Features() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            مميزاتنا
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
              style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f0fdfa 100%)'
              }}
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Cairo, sans-serif' }}>
                {feature.title}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
